import { useQuery } from '@tanstack/react-query';
import type { SalesOverviewResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

export function useSalesOverviewQuery(days: number) {
  return useQuery({
    queryKey: ['reports-sales-overview', days],
    queryFn: () => api.get<SalesOverviewResponse>(`/reports/sales-overview?days=${days}`),
    placeholderData: (prev) => prev,
  });
}
